import DataService from '../../common/services/dataService';
import Creators from './actions';

const {
  fetchSupersetReportDetailsBegin,
  fetchSupersetReportDetailsSuccess,
  fetchSupersetReportDetailsError,
  fetchSupersetTokenBegin,
  fetchSupersetTokenSuccess,
  fetchSupersetTokenError,
} = Creators;

const fetchReportDetails = (studyId) => {
  return async (dispatch) => {
    try {
      dispatch(fetchSupersetReportDetailsBegin());
      const res = await DataService.fetchReportDetails(studyId);
      dispatch(fetchSupersetReportDetailsSuccess(res.data));
    }
    catch (err) {
      dispatch(fetchSupersetReportDetailsError(err));
      throw (err);
    }
  };
};

const fetchSupersetGuestToken = (dashboardId, studyId) => {
  return async (dispatch) => {
    try {
      dispatch(fetchSupersetTokenBegin());
      const res = await DataService.fetchSupersetGuestToken(dashboardId, studyId);
      if (res.data.success) {
        dispatch(fetchSupersetTokenSuccess(res.data.guest_token, res.data.study_filter));
      } else {
        dispatch(fetchSupersetTokenError(res.data));
      }
    }
    catch (err) {
      dispatch(fetchSupersetTokenError(err));
      throw (err);
    }
  };
};

const downloadSupersetReport = (dashboardId, studyId) => {
  return async () => {
    try {
      const response = await DataService.fetchSupersetDownloadAll(
        dashboardId,
        studyId
      );

      const contentType = response.headers["content-type"] || "";

      if (contentType.includes("application/json")) {
        let errorMessage = "Failed to download report.";

        try {
          const text =
            response.data instanceof Blob
              ? await response.data.text()
              : JSON.stringify(response.data);

          const data = JSON.parse(text);
          errorMessage = data?.message || errorMessage;
        } catch (parseErr) {
          console.log(parseErr);
        }

        throw new Error(errorMessage);
      }

      const blob = new Blob([response.data], {
        type: contentType || "application/octet-stream",
      });
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      let errorMessage = "Error downloading report. Please try again later.";

      if (err?.response?.data instanceof Blob) {
        try {
          const text = await err.response.data.text();
          const data = JSON.parse(text);
          errorMessage = data?.message || errorMessage;
        } catch (parseErr) {
          console.log(parseErr);
        }
      } else if (err?.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err?.message) {
        errorMessage = err.message;
      }

      throw new Error(errorMessage);
    }
  };
};

export default {
  fetchReportDetails,
  fetchReportDetailsBegin: fetchSupersetReportDetailsBegin,
  fetchReportDetailsSuccess: fetchSupersetReportDetailsSuccess,
  fetchReportDetailsError: fetchSupersetReportDetailsError,
  fetchSupersetGuestToken,
  fetchSupersetTokenBegin,
  fetchSupersetTokenSuccess,
  fetchSupersetTokenError,
  downloadSupersetReport,
};